module.exports = __webpack_public_path__ + "img/eradusr.ffda6049.jpg";